import { TranslationFunction } from '@/src/types/translations'
import InfoIcon from '@mui/icons-material/Info'
import { Box, Typography } from '@mui/material'

const AddonsFetchFailure = ({ t }: { t: TranslationFunction<'itineraryPage.addons'> }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2.5,
                mb: 3,
                p: 3,
                borderRadius: 2,
                border: '2px solid',
                borderColor: 'warning.light',
                bgcolor: 'warning.lighter',
                position: 'relative'
            }}
        >
            <InfoIcon
                sx={{
                    color: 'warning.main',
                    fontSize: '1.75rem',
                    mt: 0.25
                }}
            />
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 600,
                        mb: 0.5,
                        color: 'warning.dark'
                    }}
                >
                    {t('addonsUnavailableTitle')}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        lineHeight: 1.6,
                        color: 'text.primary'
                    }}
                >
                    {t('addonsUnavailableSubtitle')}
                </Typography>
            </Box>
        </Box>
    )
}
export default AddonsFetchFailure
